/*
 * @Author: your name
 * @Date: 2021-01-29 17:10:32
 * @LastEditTime: 2021-02-03 15:18:10
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zcjb\src\common\Jalert\Jalert.js
 */
import Jalert from './Jalert.vue'
const JalertModal = {}

// 注册Toast
JalertModal.install = function (Vue) {
  // 生成一个Vue的子类
  // 同时这个子类也就是组件
  const JalertModalConstructor = Vue.extend(Jalert)
  // 生成一个该子类的实例
  const instance = new JalertModalConstructor()
  // 将这个实例挂载在我创建的div上
  instance.$mount(document.createElement('div'))
  // 并将此div加入全局挂载点内部
  document.body.appendChild(instance.$el)
  //定义一个外部的变量，用于控制调用多次提示组件时，清除延时器
  // 通过Vue的原型注册一个方法
  // 让所有实例共享这个方法
  const JalertModal = (id, title,text,buttonText, cb) => {
    instance.visible = true
    instance.id = id
    instance.title = title
    instance.text = text
    instance.buttonText = buttonText
    instance.cb = cb
  }
  //将方法挂载全局
  Vue.prototype.$JalertModal = JalertModal
}

export default JalertModal
